import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import AddIcon from "@mui/icons-material/Add";

/**
 * Shown on Administration → Patrol setting when there are no drawings yet.
 * Replaces the search/toolbar/table chrome until the first drawing is added.
 */
export function PatrolSettingsEmptyState({ onAddDrawing }) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 320,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2.5,
        p: 4,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: "12px",
          bgcolor: "#F9FAFB",
          border: "1px solid #E5E7EB",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MapOutlinedIcon sx={{ fontSize: 64, color: "#D1D5DB" }} />
      </Box>
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: 18,
          fontWeight: 600,
          color: "#4A5565",
        }}
      >
        No drawings yet
      </Typography>
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: 14,
          color: "#6B7280",
          maxWidth: 420,
          lineHeight: 1.5,
        }}
      >
        Upload a site floor plan to use with Digital Patrol. You can place cameras
        on the drawing after it is uploaded.
      </Typography>
      {onAddDrawing ? (
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onAddDrawing}
        sx={{
          mt: 0.5,
          textTransform: "none",
          fontFamily: "Roboto, sans-serif",
          fontSize: 14,
          fontWeight: 500,
          bgcolor: "#2932E5",
          borderRadius: "10px",
          height: 40,
          px: 2.5,
          boxShadow: "none",
          "&:hover": { bgcolor: "#1E25B8", boxShadow: "none" },
        }}
      >
        New Drawing
      </Button>
      ) : null}
    </Box>
  );
}
